import InputTypesEnum from '../../../Enums/InputTypesEnum';
import PlanningDetailsItemService from '../../../Services/PlanningDetailsItemService';
import AddFieldworkPeriodsItem from '../../../Domain/AddFieldworkPeriodsItem';

export default class AddFieldworkPeriodsWindowDescription {
  static titleForCreate = 'Add New Fieldwork Periods';
  static titleForEdit = 'Add New Fieldwork Periods';
  static itemType = AddFieldworkPeriodsItem;
  static messageOnSuccess = 'The new PlanningDetail Items have been created.';
  static finishButtonLabel = 'Create New Periods';
  static serviceFunction = async (item) => {
    await PlanningDetailsItemService.AddNewPlanningDetailItemsByPricingIds(
      item.PricingIds,
      item.NumberOfNewFieldworkPeriods
    );
    return true;
  };

  static pagesInGeneralEditWizzard = [
    {
      label: 'Add Fieldwork Periods',
      fields: [
        {
          fieldName: 'CountryInfo',
          label: '',
          className: 'col-4',
          type: InputTypesEnum.InfoCallout,
          buildContent: (item) => {
            const countryNames = item.CountryNames ?? [];
            return {
              paragraphs: ['It will be applied on the following country(ies):'],
              chips: countryNames,
              chipsLabel: countryNames.length === 1 ? 'country' : 'countries',
            };
          },
        },
        {
          fieldName: 'NumberOfNewFieldworkPeriods',
          label: 'Number of New Fieldwork Periods',
          className: 'col-8',
          type: InputTypesEnum.Number,
          validityChecker: (value) => {
            const parsed = Number(value);
            if (value === '' || value === null || !Number.isInteger(parsed) || parsed < 1) {
              return 'The number of new fieldwork periods must be a whole number of at least 1.';
            }
            return '';
          },
        },
      ],
    },
  ];
}
